import React from 'react';
import { Card, CardHeader, CardHeaderToolbar, CardBody } from '../../../../_metronic/_partials/controls';
import Pasos from '../../Public/Inscripciones/Steps/Pasos';
import { Button } from "react-bootstrap";
import { Link,Redirect } from 'react-router-dom';
import * as actionsEstado from '../../Public/Inscripciones/_redux/DetalleInscripcion/DetalleInscripcionActions';
import { useDispatch, shallowEqual, useSelector } from "react-redux";

const EstadoInscripcion = (props) => {
    //const { inscripcionNumero } = props.match.params;

    const { detalleInscripcionInformacion } = useSelector(
        state => state.detalleInscripcion,
        shallowEqual
    );
    //DISPATCH
    const dispatch = useDispatch();
    //VACIA LOS DATOS ANTES DE SALIR DE ESTE COMPONENTES
    function reiniciarDatos() {
        dispatch(actionsEstado.stateLimpiar());
    };
    return (
        <>
            {!detalleInscripcionInformacion && <Redirect to="/" /> }
            <Card>
                <CardHeader title="Inscripción Online">
                    <CardHeaderToolbar>
                        <Link to="/">
                            <Button size="sm" variant="outline-success" className="p-1 pl-5 pr-5"
                                onClick={() => reiniciarDatos()}
                            > Volver </Button>
                        </Link>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Pasos data={detalleInscripcionInformacion} />
                </CardBody>
            </Card>
        </>
    )
}

export default EstadoInscripcion;